// Single source of truth for the app's custom scrollbar.
// `scrollbarSx` is spread into a scroll container's `sx`; `globalScrollbarStyles`
// is injected once via CssBaseline so every scrollbar is custom by default.

// Colors come from the theme tokens (--app-scrollbar-*) so a theme switch
// repaints every scrollbar without rebuilding any style object.
const THUMB = "var(--app-scrollbar-thumb, rgba(255,255,255,0.18))"
const THUMB_HOVER = "var(--app-scrollbar-thumb-hover, rgba(255,255,255,0.35))"
const SIZE = 6
const RADIUS = 4

export const scrollbarSx = {
  scrollbarWidth: "thin",
  scrollbarColor: `${THUMB} transparent`,
  "&::-webkit-scrollbar": { width: SIZE, height: SIZE },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: THUMB,
    borderRadius: RADIUS,
    "&:hover": { background: THUMB_HOVER },
  },
}

export const globalScrollbarStyles = {
  "*": {
    scrollbarWidth: "thin",
    scrollbarColor: `${THUMB} transparent`,
  },
  "*::-webkit-scrollbar": { width: SIZE, height: SIZE },
  "*::-webkit-scrollbar-track": { background: "transparent" },
  "*::-webkit-scrollbar-thumb": {
    background: THUMB,
    borderRadius: RADIUS,
  },
  "*::-webkit-scrollbar-thumb:hover": { background: THUMB_HOVER },
}
